import { Button, Container, Text } from '@backstage/ui';
import { Icon } from '@iconify/react';

import classes from './Header.module.css';

export const Header = () => (
  <Container className={classes.root}>
    <Container className={classes.content}>
      <Text className={classes.header}>Welcome to iPEN</Text>
      <Text className={classes.description}>
        <b>iPEN</b>
        {' '}
        (Information Platform of Energy Networks) is
        {' '}
        <b>E.ON's central ecosystem</b>
        {' '}
        where people, organisations, data, and digital solutions come together across Energy Networks.
        {' '}
      </Text>
      <Button
        iconStart={
          <Icon icon="ri:arrow-right-s-line" />
        }
        variant="secondary"
      >
        Get Started
      </Button>
    </Container>
    <Container className={classes.image} />
  </Container>
);
